<template>
    <div>
        <rkm-area
            background-color="success"
            header-prefix-text="P"
            title="Plano - Evolução"
            type="box"
        >
            <template>
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :validations="validations.descricao"
                            name="Descrição"
                            placeholder="Insira informações adicionais sobre o plano de cuidado."
                            rows="6"
                            v-model="data.model.descricao"
                        />
                    </rkm-col>
                </rkm-row>

                <BoxIntervencao
                    :data="data"
                    class="mt-3"
                />
            </template>

            <BoxProcedimentoClinico :data="data" />

            <rkm-tabs class="mt-2">
                <rkm-tab title="Prescrição de medicamentos">
                    <BoxPrescricaoMedicamento :data="data" />
                </rkm-tab>

                <rkm-tab title="Solicitação de exames">
                    <BoxSolicitacaoExame :data="data" />
                </rkm-tab>

                <rkm-tab title="Testes rápidos">
                    <BoxTesteRapido :data="data" />
                </rkm-tab>

                <rkm-tab title="Atestados">
                    <BoxAtestado :data="data" />
                </rkm-tab>

                <rkm-tab title="Declarações de comparecimento">
                    <BoxDeclaracaoComparecimento :data="data" />
                </rkm-tab>

                <rkm-tab title="Cartas médicas">
                    <BoxCartaMedica :data="data" />
                </rkm-tab>

                <rkm-tab title="Orientações">
                    <BoxOrientacao :data="data" />
                </rkm-tab>

                <rkm-tab title="Encaminhamentos">
                    <BoxEncaminhamento :data="data" />
                </rkm-tab>

                <rkm-tab title="Compartilhamento de cuidado">
                    <BoxCompartilhamentoCuidado :data="data" />
                </rkm-tab>
            </rkm-tabs>
        </rkm-area>
    </div>
</template>

<script>
// Components.
import BoxAtestado from './components/atestado/Index'
import BoxCartaMedica from './components/carta-medica/Index'
import BoxCompartilhamentoCuidado from './components/compartilhamento-cuidado/Index'
import BoxDeclaracaoComparecimento from './components/declaracao-comparecimento/Index'
import BoxEncaminhamento from './components/encaminhamento/Index'
import BoxIntervencao from './components/intervencao/Index'
import BoxOrientacao from './components/orientacao/Index'
import BoxPrescricaoMedicamento from './components/prescricao-medicamento/Index'
import BoxProcedimentoClinico from './components/procedimento-clinico/Index'
import BoxSolicitacaoExame from './components/solicitacao-exame/Index'
import BoxTesteRapido from './components/teste-rapido/Index'

export default {
    components: {
        BoxAtestado,
        BoxCartaMedica,
        BoxCompartilhamentoCuidado,
        BoxDeclaracaoComparecimento,
        BoxEncaminhamento,
        BoxIntervencao,
        BoxOrientacao,
        BoxPrescricaoMedicamento,
        BoxProcedimentoClinico,
        BoxSolicitacaoExame,
        BoxTesteRapido,
    },
    computed: {
        validations() {
            return {
                descricao: {max: 5000},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>